<template>
	<div class="join-us">
		<!--line1-->
		<ul class="join-con">
			<li>
				<div class="title">
					<i class="x-icon-why"></i><span class="x-tit-con">Why Choose Xhorse?</span>
				</div>
				<div class="content">
					<div class="item key-p">
						<div class="lon lon-head">
							<i class="x-icon-lock x-inline"></i>
							<h3 class="x-inline" style="line-height: 59px">Flexible Position Mechanism</h3>
						</div>
						<div class="lon lon-body">
							<p>
								Xhorse provides you the various positions for R&D（Research and Development) and other positions such as marketing, administration, and designing, the R&D position accounts for over 70%. We always keep the principle that arranging appropriate works for employees according to their individual abilities and characteristics. You can easily find the most appropriate position to show your talents.</p>
						</div>
					</div>
					<div class="item key-f">
						<div class="lon lon-head">
							<i class="x-icon-team x-inline"></i>
							<h3 class="x-inline" style="line-height: 28px">
								Professional R&D Team + Better Atmosphere for
								Development</h3>
						</div>
						<div class="lon lon-body">
							<p>
								We take technology integration as the core idea of research and development, to create a laboratory type of research and development atmosphere. We have professional R&D equipment support. Our team is mainly composed of members graduated from domestic top universities(985, 211), Technical Veterans come from various fields will give you professional guidance.</p>
						</div>
					</div>
					<div class="item key-o">
						<div class="lon lon-head">
							<i class="x-icon-model x-inline"></i>
							<h3 class="x-inline" style="line-height: 44px">
								Flat-type Organization Model</h3>
						</div>
						<div class="lon lon-body">
							<p>Your voice will be easily heard. Easy to communicate with your colleagues.
								Do your job happier and more efficiently.i</p>
						</div>
					</div>
					<div class="item key-w">
						<div class="lon lon-head">
							<i class="x-icon-employe x-inline"></i>
							<h3 class="x-inline" style="line-height: 44px">
								Employee Welfare</h3>
						</div>
						<div class="lon lon-body">
							<p>
								allowance for meals, transportation, and rent. lots of holiday gifts for employees on Birthday, Children's Day, Dragon Boat Festival, etc. You'll have several chances of tourism at home and abroad each year. We also prepare thoughtful afternoon tea, holiday dinner, etc.</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<div class="x-line x-clear"></div>

		<!--line2-->
		<ul class="join-con" style="margin-bottom: 64px !important;">
			<li>
				<div class="title">
					<i class="x-icon-person"></i><span class="x-tit-con">What kind of talents are we looking for?</span>
				</div>
				<div class="content">
					<div class="mobile-pad" style="padding-left: 0px;margin-bottom: 16px;">
						<img :src="image_7" alt="Xhorse" style="width: 100%;"/>
					</div>
					<div class="key-f">
						<ul>
							<li>Rich experiences and professional skills in the fields of automobile, automation,
								CNC, HPC, optics, etc.
							</li>

							<li> Great passion and enthusiasm for the high-tech industry.</li>

							<li>
								Eager to further create your own career breakthrough and bring new value to our company.
							</li>

							<li> We hope you have integrity and team spirit.</li>

							<li> Recognize our corporate culture and core values.</li>
						</ul>
					</div>
				</div>
			</li>
		</ul>
		<div class="x-line x-clear"></div>


		<!--line3-->
		<ul class="join-con">
			<li>
				<div class="title">
					<i class="x-icon-offer"></i><span class="x-tit-con">What kind of positions do we offer?</span>
				</div>
				<div class="content">
					<ul>

						<li class="lx x-flow">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-icon-pos-1 x-inline"></i>
								<span
								class="x-inline pos-list-con">Mechanical motion control algorithm	engineer</span>
							</router-link>
						</li>


						<li class="lx x-flow">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-icon-pos-2 x-inline"></i>
								<span class="x-inline pos-list-con">QT engineer</span>
							</router-link>
						</li>


						<li class="lx x-flow">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-icon-pos-3 x-inline"></i>
								<span class="x-inline pos-list-con">Mechanical Engineers</span>
							</router-link>
						</li>


						<li class="lx x-flow">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-icon-pos-4 x-inline"></i>
								<span class="x-inline pos-list-con">Servo Drive Software Engineer</span>
							</router-link>
						</li>


						<li class="lx x-flow">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-icon-pos-5 x-inline"></i>
								<span class="x-inline pos-list-con">Servo Motor Hardware Engineer</span>
							</router-link>
						</li>


						<li class="lx x-flow" style="margin-bottom: 64px !important;">
							<router-link :to="{name: 'apply', params:{ activeName: 1, ActiveScope: 1 }}">
								<i class="x-inline"></i>
								<span class="x-inline pos-list-con x-more">+ Find more positions</span>
							</router-link>
						</li>

					</ul>
				</div>
			</li>
		</ul>
		<div class="x-line x-clear"></div>

		<!--line4-->
		<ul class="join-con">
			<li>
				<div class="title">
					<i class="x-icon-plan"></i><span class="x-tit-con">Training Plan</span>
				</div>
				<div class="content">
					<div class="plan-con">
						<img :src="image_8" alt="Xhorse"/>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
    import image_7 from '@/assets/resource/images/join/image_recruit_08.png'
    import image_8 from '@/assets/resource/images/join/image_recruit_09.png'
    export default {
        data(){
            return {
                image_7: image_7,
                image_8: image_8
            };
        }
    }

</script>

<style scoped>
	.lon-body {
		padding-left: 3.375rem;
	}

	.x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-family: Open Sans;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.lx a {
		display: block;
		width: 100%;
		height: 100%;
	}

	.content .lx:hover {
		transform: scale(1.024);
	}

	.content .lx {
		width: calc((100% - 2.25rem) / 2);
		height: 7.125rem;
		background: #FBFBFB;
		border-radius: .25rem;
		margin-bottom: 2rem;
		position: relative;
	}

	.content .lx:nth-child(odd) {
		margin-left: 0px;
	}

	.content .lx:nth-child(even) {
		margin-left: 2.25rem;
	}

	.key-f > ul > li {
		list-style-image: url("../../../assets/resource/icons/ico_sociology_square.png");
		font-family: Open Sans;
		font-size: 1rem !important;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;

	}

	.key-f > ul > li:not(:last-child) {
		margin-bottom: .625rem;
	}

	.key-f > ul {
		margin-left: .875rem;
	}

	.key-p > img {
		width: 100%;
	}

	.key-p, .key-f {
		border: none;
		width: 100%;
	}

	.item > .lon-body > p {
		font-family: Open Sans;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		padding-left: .3125rem;
	}

	.item > .lon-head > h3 {
		width: calc(100% - 3.75rem);
		font-family: Open Sans;
		font-size: 1.25rem;
		color: #515555;
		letter-spacing: 0;
		text-align: left;
	}

	.item > .lon-head {
		text-align: left;
	}

	.join-con .content {
		width: 54.5rem;
		margin-left: 7rem;
		border: none;
	}

	.content > .item {
		width: 25.75rem;
		min-height: 22.75rem;
		float: left;
		overflow: hidden;
		margin-bottom: 2.75rem;
		border: none;
	}

	.content > .item:nth-child(even) {
		margin-left: 2.75rem;
	}

	.content > .item:nth-child(odd) {
		margin-left: 0;
	}

	.join-con {
		width: 61.5rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.join-us {
		width: 100%;
		height: 100%;
	}

	.x-line {
		width: 100%;
		height: .75rem;
		border: none;
		background-color: #F7F8F8;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-bottom: 2.75rem;
	}

	.title > .x-icon-why {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_xhorse.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.x-icon-lock {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_reason_post.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
		line-height: 3.6875rem;
	}

	.x-icon-model {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_reason_administration.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .8125rem;
		margin-right: .625rem;
		line-height: 3.6875rem;
	}

	.x-icon-employe {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_reason_welfare.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .8125rem;
		margin-right: .625rem;
	}

	.x-icon-team {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_reason_team.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .3125rem;
		margin-right: .625rem;
	}

	.x-icon-plan {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_develop.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.x-icon-person {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_personnel.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.x-icon-offer {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_position.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: .625rem;
	}

	.x-icon-pos-1 {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_position_01.png");
		width: 2.75rem;
		height: 2.75rem;
		position: absolute;
		margin-right: .625rem;
		top: 2.3125rem;
		left: 1.875rem;
	}

	.x-icon-pos-2 {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_position_02.png");
		width: 2.75rem;
		height: 2.75rem;
		position: absolute;
		margin-right: .625rem;
		top: 2.3125rem;
		left: 1.875rem;
	}

	.x-icon-pos-3 {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_position_03.png");
		width: 2.75rem;
		height: 2.75rem;
		position: absolute;
		margin-right: .625rem;
		top: 2.3125rem;
		left: 1.875rem;
	}

	.x-icon-pos-4 {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_position_04.png");
		width: 2.75rem;
		height: 2.75rem;
		position: absolute;
		margin-right: .625rem;
		top: 2.3125rem;
		left: 1.875rem;
	}

	.x-icon-pos-5 {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_sociology_position_04.png");
		width: 2.75rem;
		height: 2.75rem;
		position: absolute;
		margin-right: .625rem;
		top: 2.3125rem;
		left: 1.875rem;
	}

	.pos-list-con {
		display: inline-block;
		text-align: left;
		width: calc(100% - 6.25rem);
		height: 7.125rem;
		line-height: 7.125rem;
		font-size: 1.25rem;
		margin-left: 3.75rem;
		padding-left: 1.25rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.x-more {
		font-family: Open Sans;
		font-size: 1.25rem;
		color: #1567E4;
		width: 80%;
		margin: 0 auto;
		text-align: center;
		padding: 0 !important;
	}

	.plan-con img {
		width: 80%;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/zh-cn/join/join-social.vue